import $ from 'jquery';
import Form from 'root/module/form';
import _ from 'underscore';
import Util from 'root/module/util';
import View from 'view/base';
import Cache from 'root/cache';
import Modals from 'root/modals';

export default View.extend({
    events: {
        'change input[name="trigger_type"]'             : 'onTriggerTypeChange',
        'change input[name="trigger_delay"]'            : 'updateSettings',
        'change input[name="trigger_delay_rage"]'       : 'updateSettings',
        'change input[name="frequency"]'                : 'updateSettings',
        'click input[name="oncesubmit_days_toggle"]'    : 'onToggleFrequencyDays',
        'click input[name="once_days_toggle"]'          : 'onToggleFrequencyDays',
        'click input[name="stop_days_toggle"]'          : 'onToggleFrequencyDays',
        'change input[name="oncesubmit_days"]'          : 'onChangeFrequencyDays',
        'change input[name="once_days"]'                : 'onChangeFrequencyDays',
        'change input[name="stop_days"]'                : 'onChangeFrequencyDays',
        'change input[name="trigger_action"]'           : 'onChangeElementClickSelector',
        'click .account-upgrade'                        : 'onAccountUpgrade'
    },

    dom_handlers: {
        updateSettings: function() {
            this.updateSettings();
        },
        onTriggerTypeChange: function(e) {
            const new_type = $(e.currentTarget).val();
            const old_type = this.model.get('trigger_type');

            // Save current delay before switching type
            const current_input_name = old_type === 'rage' ? 'trigger_delay_rage' : 'trigger_delay';
            const current_delay = this.$el.find(`input[name="${current_input_name}"]`).val();
            this.trigger_delay_map[old_type] = parseInt(current_delay, 10) || 0;

            // Load the corresponding delay for the new type
            const new_delay = this.trigger_delay_map[new_type] || 0;

            if (new_type === 'rage') {
                this.$el.find('input[name="trigger_delay_rage"]').val(new_delay);
            } else if (new_type === 'time') {
                this.$el.find('input[name="trigger_delay"]').val(new_delay);
            }

            this.updateSettings();
        },
        onToggleFrequencyDays: function(e) {
            if ($(e.currentTarget).prop('checked')) {
                $(e.currentTarget).parent().children('input[type="number"]').focus();
            } else {
                $(e.currentTarget).parent().children('input[type="number"]').val('');
            }

            this.updateSettings();
        },
        onChangeFrequencyDays: function(e) {
            $(e.currentTarget).parent().children('input[type="checkbox"]').prop('checked', true);
            this.updateSettings();
        },
        onAccountUpgrade: function(e) {
            Modals.choosePlan();
        },

        onChangeElementClickSelector: function(e) {
            this.renderElementClickValidation($(e.currentTarget).val());
            this.updateSettings();
        }
    },

    initialize: function() {
        this.trigger_delay_map = {
            time: 0,
            rage: 0
        };

        // Restore delay to correct type
        this.trigger_delay_map[this.model.get('trigger_type')] = this.model.get('trigger_delay');

        this.listenTo(this.model, 'change', this.render);
    },

    getSettings: function() {
        var form_data = Form.getData(this.$el);

        var frequency = form_data.frequency;
        var frequency_days = 0;

        if (form_data.frequency === 'oncesubmit' && form_data.oncesubmit_days_toggle.includes(1)) {
            // convert oncesubmit_days to int
            frequency_days = parseInt(form_data.oncesubmit_days, 10);
        } else if (form_data.frequency === 'once' && form_data.once_days_toggle.includes(1)) {
            // convert once_days to int
            frequency_days = parseInt(form_data.once_days, 10);
        } else if (form_data.frequency === 'close' && form_data.stop_days_toggle.includes(1)) {
            // convert stop_days to int
            frequency_days = parseInt(form_data.stop_days, 10);
        }

        if (frequency_days > 0) {
            frequency += '_' + frequency_days;
        }

        // do some sepcial treatment for trigger_action
        // when the trigger_type is element, if the content has no . or #, add a . to the beginning
        var trigger_action = form_data.trigger_action.trim();
        if (form_data.trigger_type === 'element' && trigger_action) {
            if (trigger_action !== '') {
                // Extract the first part of the string before ><: and blank space
                trigger_action = trigger_action.split(/[><:\s]/)[0];

                // Check if the content contains . or #
                if (!trigger_action.match(/[.#\[\]><:]/)) {
                    // If not, assume it's a class selector
                    trigger_action = '.' + trigger_action;
                }

                // Validate the selector
                var valid_selector_regex = /^(#[a-zA-Z0-9_-]+)|([a-zA-Z]+(\.[a-zA-Z]+)?(\[[^\]]+\])?[\w-]*)$/;
                if (!valid_selector_regex.test(trigger_action)) {
                    // Invalid selector, reset to empty string
                    trigger_action = '';
                }

                // Check if the selector is valid
                if (!this.isValidQuerySelector(trigger_action)) {
                    // Invalid selector, reset to empty string
                    trigger_action = '';
                }
            }

            this.$el.find('input[name="trigger_action"]').val(trigger_action);
            form_data.trigger_action = trigger_action;
        }

        var trigger_delay = form_data.trigger_type === 'rage' ? form_data.trigger_delay_rage : form_data.trigger_delay;

        var settings_data = {
            trigger_type   : form_data.trigger_type,
            trigger_delay  : trigger_delay,
            trigger_action : form_data.trigger_action, // TODO action based trigger
            frequency      : frequency
        };

        return settings_data;
    },

    isValidQuerySelector: function(selector) {
        try {
            document.querySelector(selector);
            return true;
        } catch (e) {
            return false;
        }
    },

    renderElementClickValidation: function(selector) {
        // add delay to avoid too many requests
        if (this.renderElementClickValidationTimeout) {
            clearTimeout(this.renderElementClickValidationTimeout);
        }

        this.renderElementClickValidationTimeout = setTimeout(() => {
            Cache.app.request({
                cache: 120,
                action: 'survey/checkSelector',
                data: {
                    survey_id: this.model.get('id'),
                    selector: selector
                },
                success: (response) => {
                    if (response && response.length > 0) {
                        // loops through the response and generate survey name list with comma
                        var project_name_list = response.map((survey) => {
                            return survey.project_name;
                        }).join(', ');

                        this.$el.find('.selector-warning').text('The same element selector is used in Survey: "' + project_name_list + '".');
                        this.$el.find('.selector-warning').show();
                    } else {
                        // clean text
                        this.$el.find('.selector-warning').text('');
                        this.$el.find('.selector-warning').hide();
                    }
                }
            });
        }, 500);
    },

    updateSettings: function() {
        var settings = this.getSettings();
        this.model.set(settings);
    },

    render: function() {
        var trigger_type = this.model.get('trigger_type');

        var content =
        '<hr class="medium">' +
        '<div class="setting-title">Trigger</div>' +
        '<div class="setting-subtitle">Select when the survey starts showing</div>' +
        '<div class="divider-12"></div>' +
        '<div class="trigger-options">' +
            '<div class="trigger-option">' +
                '<input id="time_based" type="radio" name="trigger_type" value="time">' +
                '<label for="time_based">Time-based</label>' +
                '<div class="trigger-value trigger-delay" data-val="time">' +
                    '<div>' +
                        '<input type="number" name="trigger_delay" min="0" class="solid compact">' +
                        '<label>seconds after page is loaded</label>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            (Cache.account.hasFeature('survey_trigger_advanced') ? '' :
            '<button type="button" class="account-upgrade float-right tiny shiny"><span>UPGRADE</span></button>') +

            '<div class="trigger-option">' +
                '<input id="element_type" type="radio" name="trigger_type" value="element">' +
                '<label for="element_type">Trigger the survey on Element Click</label>' +
                '<div class="trigger-element" data-val="element">' +
                    '<input type="text" name="trigger_action" class="solid compact medium" placeholder="e.g. #my-button or .my-button">' +
                    '<div class="selector-warning text-warning text-medium margin-top-8"></div>' +
                '</div>' +
            '</div>' +
            '<div class="trigger-option">' +
                '<input id="rage_type" type="radio" name="trigger_type" value="rage">' +
                '<label for="rage_type">Trigger the survey on Rage Click</label>' +
                '<div class="trigger-value trigger-delay" data-val="time">' +
                '<div>' +
                    '<input type="number" name="trigger_delay_rage" min="0" class="solid compact">' +
                    '<label>seconds after the rage click</label>' +
                '</div>' +
            '</div>' +
            '</div>' +
            '<div class="trigger-option">' +
                '<input id="action_based" type="radio" name="trigger_type" value="api">' +
                '<label for="action_based">Trigger the survey using <a class="primary" href="https://docs.userback.io/docs/javascript-sdk#section-survey" target="help" rel="noopener">JavaScript SDK <i class="fa-solid fa-up-right-from-square fa-xs"></i></a></label>' +
            '</div>' +
            /* TODO: action based trigger
            '<div class="trigger-option">' +
                '<input id="action_based" type="radio" name="trigger_type" value="action">' +
                '<label for="action_based">Action-based</label>' +
                '<div class="trigger-value trigger-action" data-val="action">' +
                    '<div>' +
                        '<input type="radio" name="trigger_action" value="action">' +
                        '<label>When a user scrolls half way down the page</label>' +
                    '</div>' +
                    '<div>' +
                        '<input type="radio" name="trigger_action" value="action">' +
                        '<label>When a user is about to leave the page (desktop only)</label>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            */
        '</div>' +

        '<div class="divider-24"></div>' +

        '<div class="setting-subtitle">Select when the survey stops showing</div>' +
        '<div class="divider-12"></div>' +
        '<div>' +
            '<input id="survey_frequency_once_submit" type="radio" name="frequency" value="oncesubmit">' +
            '<label for="survey_frequency_once_submit">' +
                '<div class="margin-bottom-8">After the survey is submitted</div>' +
                '<div class="text-info">The survey will continue to show until users respond</div>' +
            '</label>' +
            '<div class="trigger-value trigger-frequency">' +
                '<div class="flex-start">' +
                    '<input type="checkbox" id="oncesubmit_days" name="oncesubmit_days_toggle" value="1">' +
                    '<label for="oncesubmit_days"></label>' +
                    'Restart after<input type="number" name="oncesubmit_days" min="1" max="1000" class="solid compact">days' +
                '</div>' +
            '</div>'+
        '</div>' +
        '<div class="divider-16"></div>' +
        '<div>' +
            '<input id="survey_close" type="radio" name="frequency" value="close">' +
            '<label for="survey_close">' +
                '<div class="margin-bottom-8">After the survey is submitted or closed</div>' +
                '<div class="text-info">The survey will continue to show until users either respond or close it</div>' +
            '</label>' +
            '<div class="trigger-value trigger-frequency">' +
                '<div class="flex-start">' +
                    '<input type="checkbox" id="stop_days" name="stop_days_toggle" value="1">' +
                    '<label for="stop_days"></label>' +
                    'Restart after<input type="number" name="stop_days" min="1" max="1000" class="solid compact">days' +
                '</div>' +
            '</div>'+
        '</div>' +
        '<div class="divider-16"></div>' +
        '<div>' +
            '<input id="survey_frequency_once" type="radio" name="frequency" value="once">' +
            '<label for="survey_frequency_once">' +
                '<div class="margin-bottom-8">After the survey is displayed</div>' +
                '<div class="text-info">The survey will only show once, even if users don\'t respond</div>' +
            '</label>' +
            '<div class="trigger-value trigger-frequency">' +
                '<div class="flex-start">' +
                    '<input type="checkbox" id="once_days" name="once_days_toggle" value="1">' +
                    '<label for="once_days"></label>' +
                    'Restart after<input type="number" name="once_days" min="1" max="1000" class="solid compact">days' +
                '</div>' +
            '</div>'+
        '</div>' +
        '<div class="divider-16"></div>' +
        '<div>' +
            '<input id="survey_frequency_always" type="radio" name="frequency" value="always">' +
            '<label for="survey_frequency_always">' +
                '<div class="margin-bottom-8">Never stops, even after the survey is submitted</div>' +
                '<div class="text-info">The survey will always show, even after users respond</div>' +
            '</label>' +
        '</div>';

        this.$el.html(content);

        var frequency = this.model.get('frequency').replace(/_[0-9]*/, '');
        var frequency_days = parseInt(this.model.get('frequency').replace(/[a-z]*_/, ''), 10);

        Form.setData(this.$el, {
            trigger_type           : trigger_type,
            trigger_delay          : this.model.get('trigger_delay'),
            trigger_delay_rage     : this.model.get('trigger_delay'),
            trigger_action         : this.model.get('trigger_action'),
            frequency              : frequency,
            oncesubmit_days        : frequency === 'oncesubmit' ? frequency_days : '',
            once_days              : frequency === 'once' ? frequency_days : '',
            oncesubmit_days_toggle : frequency === 'oncesubmit' && frequency_days > 0 ? [1] : 0,
            once_days_toggle       : frequency === 'once' && frequency_days > 0 ? [1] : 0,
            stop_days              : frequency === 'close' ? frequency_days : '',
            stop_days_toggle       : frequency === 'close' && frequency_days > 0 ? [1] : 0
        });

        // show warning message when load this view.
        if (trigger_type === 'element') {
            this.renderElementClickValidation(this.model.get('trigger_action'));
        }

        if (!Cache.account.hasFeature('survey_trigger')) {
            this.$el.find('input[type="radio"]').prop('disabled', true);
            this.$el.find('input[type="checkbox"]').prop('disabled', true);
            this.$el.find('input[type="number"]').prop('disabled', true);
            this.$el.find('input[type="text"]').prop('disabled', true);
        }

        if (!Cache.account.hasFeature('survey_trigger_advanced')) {
            this.$el.find('input[name="trigger_type"][value="element"]').prop('disabled', true);
            this.$el.find('input[name="trigger_type"][value="rage"]').prop('disabled', true);
        }

        return this;
    }
});
